import { useFormikContext } from 'formik';
import { observer } from 'mobx-react';
import { Button, Form, Spinner } from 'react-bootstrap';
import Select from 'react-select';

const PackhouseAssessmentForm = ({ onCancel }) => {
  const {
    values,
    errors,
    isSubmitting,
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldValue
  } = useFormikContext();

  const hpawResultOptions = [
    { label: 'High', value: 'high' },
    { label: 'Low', value: 'low' }
  ];
  const qcRersultOptions = [
    { label: 'Pass', value: 'pass' },
    { label: 'Fail', value: 'fail' }
  ];

  return (
    <>
      <Form noValidate onSubmit={handleSubmit}>
        <Form.Group className='mb-3' controlId='date'>
          <Form.Label>Date</Form.Label>
          <Form.Control
            type='date'
            onChange={handleChange}
            onBlur={handleBlur}
            value={(values.date || '').slice(0, 10)}
            placeholder='Select date'
            isInvalid={!!errors.date}
          />
          <Form.Control.Feedback type='invalid'>
            {errors.date}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group className='mb-3' controlId='hpaw_result'>
          <Form.Label>HPAW Result</Form.Label>
          <Select
            name='hpaw_result'
            placeholder='Select result...'
            options={hpawResultOptions}
            value={hpawResultOptions.find(
              (hro) => hro.value === values.hpaw_result
            )}
            onChange={(option) => {
              setFieldValue('hpaw_result', option.value);
            }}
            styles={{
              control: (base) => ({
                ...base,
                ...(errors.hpaw_result && { borderColor: '#dc3545' })
              })
            }}
          />
          {errors.hpaw_result ? (
            <small className='text-danger'>{errors.hpaw_result}</small>
          ) : null}
        </Form.Group>
        <Form.Group className='mb-3' controlId='qc_result'>
          <Form.Label>QC Result</Form.Label>
          <Select
            name='qc_result'
            placeholder='Select type...'
            options={qcRersultOptions}
            value={qcRersultOptions.find(
              (qro) => qro.value === values.qc_result
            )}
            onChange={(option) => {
              setFieldValue('qc_result', option.value);
            }}
            styles={{
              control: (base) => ({
                ...base,
                ...(errors.qc_result && { borderColor: '#dc3545' })
              })
            }}
          />
          {errors.qc_result ? (
            <small className='text-danger'>{errors.qc_result}</small>
          ) : null}
        </Form.Group>

        <Button variant='primary' type='submit'>
          {isSubmitting ? (
            <Spinner className='mx-3' animation='border' size='sm' />
          ) : (
            'Submit'
          )}
        </Button>{' '}
        <Button variant='secondary' type='button' onClick={onCancel}>
          Cancel
        </Button>
      </Form>
    </>
  );
};

export default observer(PackhouseAssessmentForm);

